import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { XrkButton } from '@/components/vant/index';

import native from '@/utils/native';


export default /*#__PURE__*/_defineComponent({
  __name: 'test',
  setup(__props) {

// import { onMounted } from 'vue';
const jump = () => {
  native.method.authenticationDone();
};
const close = () => {
  native.method.close();
};

const faceFail = () => {
  native.method.faceAuthFile({ tmName: 'tmName', phone: '11111111111' });
};

const faceSuccess = () => {
  native.method.faceAuthComplete({ token: 'token', phone: '11111111111' });
};
// onMounted(() => {
//   native.method.authenticationDone();
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" 测试 "),
    _createElementVNode("div", null, [
      _createVNode(_unref(XrkButton), { onClick: jump }, {
        default: _withCtx(() => [
          _createTextVNode("实名认证完成")
        ]),
        _: 1
      }),
      _createVNode(_unref(XrkButton), { onClick: close }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      }),
      _createVNode(_unref(XrkButton), { onClick: faceFail }, {
        default: _withCtx(() => [
          _createTextVNode("人脸识别失败")
        ]),
        _: 1
      }),
      _createVNode(_unref(XrkButton), { onClick: faceSuccess }, {
        default: _withCtx(() => [
          _createTextVNode("人脸识别成功")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})